import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private tokenKey = 'mileexpress_token';

  constructor(private http: HttpClient) {}

  login(username: string, password: string): Observable<void> {
    const body = {
      grant_type: 'password',
      client_id: 1, // ajuste se necessário
      client_secret: 'xwShEAUn6MJ82AZzaECmypbp6PmjTM3HPhDYaxE7', // ajustar / mover p/ backend para segurança
      username,
      password,
      scope: '*'
    };
    return this.http.post<any>(environment.apiOauth, body).pipe(
      map(res => {
        if (res?.access_token) {
          localStorage.setItem(this.tokenKey, res.access_token);
        } else {
          throw new Error('Token não recebido');
        }
      })
    );
  }

  logout() {
    localStorage.removeItem(this.tokenKey);
  }

  getToken(): string | null {
    return localStorage.getItem(this.tokenKey);
  }

  isLoggedIn(): boolean {
    return !!this.getToken();
  }
}
